import { bemComponent } from '@99designs/utils/app';

export default bemComponent('button-list', 'ButtonList');
export const ButtonListItem = bemComponent('button-list__item', 'ButtonListItem');



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/ButtonList.jsx